module.exports = __webpack_public_path__ + "img/mrxls.03c6ab82.png";